export default __webpack_public_path__ + "static/media-forbes-af9b99854f81e74e263f61f3061fc9ce.png";